import React, { useState } from "react";
import { createPaymentLink } from "../../api"; 
import { useNavigate } from "react-router-dom";

export default function PaymentLinkForm() {
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    email: "",
    amount: "",
    note: "",
    networks: [],
  });

  const [showPopup, setShowPopup] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const user_token = user.user_token;
  const secret_key = user.secret_key;
  const api_password = user.api_password;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(paymentLink);
      alert("✅ Payment link copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy: ", err);
      alert("❌ Could not copy the link. Please copy manually.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        user_token,
        api_password,
        secret_key,
        name: formData.name,
        phone_number: formData.phone_number,
        email: formData.email,
        chain: formData.networks[0] || "ERC20",
        amount: formData.amount,
        redirect_url: "https://crypto.switchpay.in.net/dashboard",
      };

      const response = await createPaymentLink(payload);

      if (response.success && response.payment_page) {
        // ✅ Show popup with payment link instead of redirect
        setPaymentLink(response.payment_page);
        setShowPopup(true);
      } else {
        alert(`❌ Failed: ${response.message}`);
      }
    } catch (err) {
      alert(`❌ Error: ${err.message || "Something went wrong"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-inner">
        <div className="main-content-wrap">
          <div className="tf-container">
            <div className="row">
              <div className="min-h-screen bg-white flex items-center justify-center px-3">
                <form
                  onSubmit={handleSubmit}
                  className="bg-white w-full max-w-lg p-5 border rounded shadow-sm"
                >
                  <h2 className="h4 text-center fw-bold mb-4 text-black">
                    Generate Payment Link
                  </h2>

                  {/* Name */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold text-black" style={{ fontSize: "20px" }}>Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control border border-black rounded"
                      required
                    />
                  </div>

                  {/* Phone */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold text-black" style={{ fontSize: "20px" }}>Phone</label>
                    <input
                      type="text"
                      name="phone_number"
                      value={formData.phone_number}
                      onChange={handleChange}
                      className="form-control border border-black rounded"
                      required
                    />
                  </div>

                  {/* Email */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold text-black" style={{ fontSize: "20px" }}>Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control border border-black rounded"
                      required
                    />
                  </div>

                  {/* Amount */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold text-black" style={{ fontSize: "20px" }}>Amount</label>
                    <input
                      type="number"
                      name="amount"
                      value={formData.amount}
                      onChange={handleChange}
                      className="form-control border border-black rounded"
                      required
                    />
                  </div>

                  {/* Note */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold text-black" style={{ fontSize: "20px" }}>Note</label>
                    <input
                      type="text"
                      name="note"
                      value={formData.note}
                      onChange={handleChange}
                      className="form-control border border-black rounded"
                    />
                  </div>

                  {/* Networks */}
                  <div className="mb-4">
                    <label className="form-label fw-semibold text-black" style={{ fontSize: "20px" }}>
                      Select Network
                    </label>
                    <div className="d-flex gap-3">
                      {["BEP20", "ERC20","TRC20"].map((net) => (
                        <div className="form-check" key={net}>
                          <input
                            className="form-check-input"
                            type="radio"
                            name="network"
                            value={net}
                            checked={formData.networks[0] === net}
                            onChange={(e) =>
                              setFormData({ ...formData, networks: [e.target.value] })
                            }
                            id={net}
                          />
                          <label
                            className="form-check-label text-black mt-2"
                            htmlFor={net}
                            style={{ fontSize: "20px", marginLeft: "5px" }}
                          >
                            {net}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Submit */}
                  <button
                    type="submit"
                    className="btn btn-dark w-100 py-2 my-2 fw-semibold"
                    style={{ fontSize: "20px" }}
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Generate Payment Link"}
                  </button>
                </form>

                {/* Popup */}
                {showPopup && (
                  <div className="fixed inset-0 d-flex align-items-center justify-content-center bg-black bg-opacity-50">
                    <div className="bg-white p-5 rounded shadow border border-black text-center" style={{ width: "600px", maxWidth: "90%" }}>
                      <h3 className="h4 fw-bold text-black mb-4">✅ Payment Link Generated</h3>

                      <input
                        disabled
                        className="form-control text-black text-center"
                        style={{ fontSize: "20px", height: "50px", marginTop: "20px", marginBottom: "20px" }}
                        value={paymentLink}
                      />
                      <div className="d-flex justify-content-center gap-3">
                        <button onClick={handleCopy} className="btn btn-dark px-5 py-2" style={{ fontSize: "20px" }}>
                          Copy Link
                        </button>
                        <button onClick={() => setShowPopup(false)} className="btn btn-outline-dark px-5 py-2" style={{ fontSize: "20px" }}>
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
